document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("csq-questionnaire-form");
  const step = CSQ.helpers.getQueryStringParameter("id");

  if (form === null || step !== "objectives_and_financial_situation") {
    return;
  }

  const hasInvestmentDurabilityExpectations = form.querySelector("#csq-has-investment-durability-expectations");
  const investmentDurabilityExpectations = form.querySelector("#csq-investment-durability-expectations");

  hasInvestmentDurabilityExpectations.addEventListener("change", (e) => {
    if (e.target.tagName !== "INPUT" || e.target.type !== "radio") {
      return;
    }

    if (e.target.value === "false" && e.target.checked) {
      investmentDurabilityExpectations.style.display = "none";
      investmentDurabilityExpectations.querySelectorAll("input, textarea").forEach(CSQ.helpers.clearInputField);
    } else {
      investmentDurabilityExpectations.style.removeProperty("display");
    }
  });
}, false);
